var formatMonth = function (numberOfMonths, translationFn) {
    return "".concat(numberOfMonths, " ").concat(numberOfMonths === "1"
        ? translationFn("grid.month")
        : translationFn("grid.months"));
};
export default formatMonth;
//# sourceMappingURL=formatMonth.js.map